// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.VersionUpdateInfo_main__OsrZI {
    width: 100%;
    height: 100%;
}

.VersionUpdateInfo_header__lEW3Q {
    height: 35px;
    margin-bottom: 25px;
}

.VersionUpdateInfo_title__cbf-U {
    font-size: 30px;
}

.VersionUpdateInfo_container__xxY\\+M {
    width: 100%;
    min-height: calc(100% - 60px);
    padding: 20px;
    border-radius: 6px;
    background-color: #ffffff;
}

.VersionUpdateInfo_add_box__lthB4 {
    width: 100%;
    height: 50px;
}

.VersionUpdateInfo_table_box__mECPG {
    width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/pages/admin/components/VersionUpdateInfo/index.module.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,6BAA6B;IAC7B,aAAa;IACb,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;AACf","sourcesContent":[".main {\n    width: 100%;\n    height: 100%;\n}\n\n.header {\n    height: 35px;\n    margin-bottom: 25px;\n}\n\n.title {\n    font-size: 30px;\n}\n\n.container {\n    width: 100%;\n    min-height: calc(100% - 60px);\n    padding: 20px;\n    border-radius: 6px;\n    background-color: #ffffff;\n}\n\n.add_box {\n    width: 100%;\n    height: 50px;\n}\n\n.table_box {\n    width: 100%;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"main": `VersionUpdateInfo_main__OsrZI`,
	"header": `VersionUpdateInfo_header__lEW3Q`,
	"title": `VersionUpdateInfo_title__cbf-U`,
	"container": `VersionUpdateInfo_container__xxY+M`,
	"add_box": `VersionUpdateInfo_add_box__lthB4`,
	"table_box": `VersionUpdateInfo_table_box__mECPG`
};
export default ___CSS_LOADER_EXPORT___;
